<template>
  <div>
    <!-- upload在项目中，不需要处理 -->
    <div style="width: 100%;margin-bottom: 20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>订单评论管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search" :model="formInline" size="small">
      <el-form-item label="订单编号：">
        <el-input size="small" placeholder="请输入订单编号" v-model="formInline.orderSn"></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="评论时间">
        <datapicker @click="changetime1" :startTime="formInline.rewardTime" :endTime="formInline.rewardEndTime"></datapicker>
      </el-form-item>
      <el-form-item label="评价星级">
        <el-select v-model="formInline.scores" placeholder="全选择评价星级">
          <el-option label="全部" :value='0'></el-option>
          <el-option label="五星" :value='5'></el-option>
          <el-option label="四星" :value='4'></el-option>
          <el-option label="三星" :value='3'></el-option>
          <el-option label="二星" :value='2'></el-option>
          <el-option label="一星" :value='1'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="显示状态">
        <el-select v-model="formInline.ischeckeds" placeholder="全选择评价星级">
          <el-option label="全部" value="0"></el-option>
          <el-option label="显示" value="1"></el-option>
          <el-option label="影藏" value="2"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="评价方式">
        <el-select v-model="formInline.sources" placeholder="全选择评">
          <el-option label="全部" value="0"></el-option>
          <el-option label="用户自评" value="self"></el-option>
          <el-option label="默认好评" value="auto"></el-option>

        </el-select>
      </el-form-item>
   
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button>
        <el-button size="small" type="danger" icon="el-icon-plus" @click="handleaddcomment">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border  stripe
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="orderNn" label="订单编号" width="230" align="center">
      </el-table-column>
      <el-table-column sortable prop="goodsName" label="商品名称" width="200" align="center">
      </el-table-column>

      <el-table-column prop="content" label="评价内容" min-width="300" align="center">
        <template slot-scope="scope">

          <div style="margin-bottom: 20px;">评价：{{scope.row.content}}</div>
          <div v-if="scope.row.reply" style="width: 100%;border-top:1px solid #EBEEF5 ;padding-top: 20px;">回复：{{scope.row.reply }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="评价星级" width="100" align="center">
        <template slot-scope="scope">

          <div>{{fomattatStart(scope.row.score)}}</div>
        </template>
      </el-table-column>

      <el-table-column sortable label="买家" width="200" align="center">
        <template slot-scope="scope">
          <el-image style="width: 60px; height: 60px" :src="scope.row.userImg"></el-image>
          <div>
              <el-link type="primary" @click="touserDetail(scope.row)">{{scope.row.userName}}</el-link>
          </div>  
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="订单时间" width="200" align="center">
        <template slot-scope="scope">
          <div>{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}</div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作"  min-width="150"   fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handlehidden(scope.$index, scope.row)" :type="scope.row.ischecked==0?'warning':'info'">{{scope.row.ischecked==0?'隐藏':'显示'}}</el-button>
          <el-button size="mini" type="primary" @click="reply(scope.$index, scope.row)">回复</el-button>
          <!-- <el-button size="mini" type="danger" @click="handleaddcomment(scope.$index, scope.row)" icon="el-icon-edit">评价</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
   <el-dialog
      :close-on-click-modal="false" title="增加评论" :visible.sync="addFormVisible" width="40%" @click="closeDialog" center v-loading="loading2">
      <el-form class="user-search" size="small">
        <el-form-item label="选择商品">
          <el-select placeholder="请选择选择商品" v-model="addForm.goodsId" filterable @change="handleselectChange">

            <el-option :label="item.goodsName" :value="item.goodsId" v-for="item in goodsList" :key="item.goodsId">
             
            </el-option>

          </el-select>
        </el-form-item>


        <el-form-item label="选择用户">
          <el-select v-model="addForm.uid" placeholder="请选择用户" filterable @change="handleselectUser">

            <el-option :label="it.name" :value="it.uid" v-for="it in userList" :key="it.uid">
              <span style="float: left">{{ it.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ it.goodsName }}</span>
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input   v-model="userSelect.orderSn" readonly placeholder="选择用户后自动显示" style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item label="订单信息：">
          <el-input   v-model="userSelect.goodsName" readonly placeholder="选择用户后自动显示"  style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item label="订单金额：">
          <el-input   v-model="userSelect.payAmount" readonly placeholder="选择用户后自动显示"  style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item label="评价星级">

          <el-rate v-model="addForm.score"></el-rate>
        </el-form-item>
        <el-form-item label="添加评论：">
          <el-input type="textarea" :rows="5" placeholder="请输入评论" v-model="addForm.content"></el-input>
        </el-form-item>
        <el-form-item>
          <div>添加图片：</div>
          <el-upload action="https://testm.chunpinkeji.com/api/uploadFileOss" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :limit="4"
            :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
         <el-dialog
      :close-on-click-modal="false" :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>

      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('addForm')">提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 回复评论 -->

   <el-dialog
      :close-on-click-modal="false" title="回复评论" :visible.sync="replyFormVisible" width="40%" @click="closeDialog" center>

      <el-form class="user-search" :model="replycommentForm" size="small">
        <el-form-item label="订单编号：">
          <el-input size="small" placeholder="请输入订单编号" :value="replycommentForm.orderSn" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" :value="replycommentForm.goodsSame" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="评论内容：">
          <el-input type="textarea" :rows="5" placeholder="评论内容" :value="replycommentForm.content" :disabled="true">
          </el-input>
        </el-form-item>



        <el-form-item label="回复评论：">
          <el-input type="textarea" :rows="5" placeholder="回复评论" v-model="replycommentForm.commentReply"></el-input>
        </el-form-item>


      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitreplyForm('replycommentForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<!-- start: 0
order_sn: 
goods_name: 
startTime: 
endTime: 
score: 
ischecked: 
source: -->
<script>


  import { getUserCommentList } from '../../api/basisMG.js'
  import Pagination from '../../components/Pagination'
    import datapicker from '../../components/datapicker'
    // 导出模块
    export default {
        components: {
            Pagination,
            datapicker
           
        },

    data() {
      //数据  
      return {
        // s商品列表
        goodsList: [],
        // 用户订单表
        userList: [],
        formInline: { 
          startTime: '',
          endTime: '',
        },
        time: [],
        childMsg: {
          currentPage: 0,
          totalPages: 1
        },

        countNum: 10,
        totalPages: 1,
        listData: [ ],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 5,
          total: 10,
          start:0,
          length:5
        },
        //   添加评论弹框
        addFormVisible: false,
        // 评论内容
        addForm: {
          score: 5,
          goodsId: '',
          content: '',
          uid: ''
        },
        // 回复评论
        replycommentForm: {},
        // 图片上传
        dialogImageUrl: '',
        dialogVisible: false,
        replyFormVisible: false,
        loading: true,
        uploadData: [],
        fileList: [],
        userSelect: {},
        loading2: true
      };
    },
   
    watch: {},

    methods: {
      touserDetail(row){
                this.$router.push({path:'/user/userDetail',query: {uid: row.uid}})
      },
     //   select 选择
     handleselectChange(value) {
 
      let param = { goodsId: value }
      console.log(param)

      //  getOrderListByGoodsId(param).then(res => {
        
      //    if (!res.error_code) {
      //      this.userList = res.data
      //      this.addForm.uid = ''
      //    }
      //  })
    },
      handleselectUser(value) {
        console.log(value)
        let arr = this.userList
        arr.forEach(element => {
          console.log(element.uid)
          if (element.uid == value) {
            this.userSelect = element
          }
        });
        // this.userSelect = value
        // console.log('handleselectUser', this.userSelect)
      },
      //   获得商品列表
      // getgoodsData() {

      //   getGoodsList({}).then(res => {
        
      //     this.goodsList = res.data.aaData

      //   })
      // },
      addFun() { },
      // 查询的时候页面清空
      search() {
        this.pageparm.currentPage  = 1
        this.pageparm.pageSize =  10
        this.pageparm.start = 0
        this.pageparm.length = 10

        this.getdata(this.formInline)
      },
      submitFun() { },
      fomattatStart(data) {
        return data == 1 ? '一星' : data == 1 ? '二星' : data == 1 ? '三星' : data == 1 ? '四星' : '五星'
      },
      clear() {
        this.formInline = {
          start: 0,
          length: 10,   
        }
        this.getdata(this.formInline)
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.currentPage  = parm.currentPage
                this.pageparm.pageSize =  parm.pageSize 
                this.pageparm.start  = parm.currentPage - 1
                this.pageparm.length =  parm.pageSize 
                this.formInline.start = parm.currentPage - 1
                this.formInline.length = parm.pageSize
                this.getdata(this.formInline)
      },
      changetime1(val){
    
               if(val.length){
                   this.formInline.startTime = val[0]
                   this.formInline.endTime = val[1]
               }else{
                   this.formInline.startTime = ""
                   this.formInline.endTime = ""
               }
           },
      getdata() {
        let param = this.formInline  
        param.start = this.pageparm.start
        param.length = this.pageparm.length
        getUserCommentList(param).then(res => {
          this.saveParams(this.$route.path,param)
          if (res.code == 200) {
            this.pageparm.total = res.data.totalElements
          this.listData = res.data.content
          this.loading = false
          }
         
          // this.formInline = {}


        }).catch(err => {
          console.log(err)

        })
      },
      // 评论框
      closeDialog() {
        this.addFormVisible = false
        this.replyFormVisible = false
      },
      handleaddcomment() {

        this.addFormVisible = true
        // this.addForm = row

      },

      //  图片上传
      handleRemove(file, fileList) {
        this.uploadData = fileList
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        //   console.log('handleSuccess261',response,file,fileList)

        this.uploadData = fileList
      
      },
     
      // 回复评论
      reply(index, row) {
        this.replyFormVisible = true
        this.replycommentForm = row
        console.log(this.replycommentForm)
      },
  
      
    },

    beforeCreate() { },

    created() {
      this.getParams(this.$route.path)
      this.getdata(this.formInline)


    },

    beforeMount() { },

    mounted() { },

    beforeUpdate() { },

    updated() { },

    beforeDestroy() { },

    destroyed() { }
  };
</script>
<style>
  /**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
</style>